module.exports = __webpack_public_path__ + "static/media/icon-logs.ce8d9497.svg";